/* tslint:disable */
/* eslint-disable */
/**
 * Farseer API
 * Farseer API
 *
 * The version of the OpenAPI document: 3
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 *
 * @export
 * @enum {string}
 */
export var AuditLogType;
(function (AuditLogType) {
    AuditLogType["Login"] = "LOGIN";
    AuditLogType["UserCreate"] = "USER.CREATE";
    AuditLogType["UserDelete"] = "USER.DELETE";
    AuditLogType["UserUpdate"] = "USER.UPDATE";
    AuditLogType["SheetCreate"] = "SHEET.CREATE";
    AuditLogType["SheetUpdate"] = "SHEET.UPDATE";
    AuditLogType["SheetDelete"] = "SHEET.DELETE";
    AuditLogType["SheetDuplicate"] = "SHEET.DUPLICATE";
    AuditLogType["SheetMove"] = "SHEET.MOVE";
    AuditLogType["DocumentCreate"] = "DOCUMENT.CREATE";
    AuditLogType["DocumentUpdate"] = "DOCUMENT.UPDATE";
    AuditLogType["DocumentDelete"] = "DOCUMENT.DELETE";
    AuditLogType["DocumentDuplicate"] = "DOCUMENT.DUPLICATE";
    AuditLogType["TagCreate"] = "TAG.CREATE";
    AuditLogType["TagCreateBatch"] = "TAG.CREATE_BATCH";
    AuditLogType["TagUpdate"] = "TAG.UPDATE";
    AuditLogType["TagUpdateBatch"] = "TAG.UPDATE_BATCH";
    AuditLogType["TagDelete"] = "TAG.DELETE";
    AuditLogType["TagDeleteBatch"] = "TAG.DELETE_BATCH";
    AuditLogType["TagDeleteChildren"] = "TAG.DELETE_CHILDREN";
    AuditLogType["TagDeleteData"] = "TAG.DELETE_DATA";
    AuditLogType["CellCreate"] = "CELL.CREATE";
    AuditLogType["CellDuplicate"] = "CELL.DUPLICATE";
    AuditLogType["CellMove"] = "CELL.MOVE";
    AuditLogType["CellCopy"] = "CELL.COPY";
    AuditLogType["CellRemove"] = "CELL.REMOVE";
    AuditLogType["CellUpdate"] = "CELL.UPDATE";
    AuditLogType["CellDelete"] = "CELL.DELETE";
})(AuditLogType || (AuditLogType = {}));
export function AuditLogTypeFromJSON(json) {
    return AuditLogTypeFromJSONTyped(json, false);
}
export function AuditLogTypeFromJSONTyped(json, ignoreDiscriminator) {
    return json;
}
export function AuditLogTypeToJSON(value) {
    return value;
}
